import { Toaster as Sonner } from 'sonner';

// Wrapper de sonner para el panel admin. Tema claro (el panel es
// neutro), richColors para que éxito/error tengan color propio.
export type ToasterProps = React.ComponentProps<typeof Sonner>;

export function Toaster(props: ToasterProps) {
  return <Sonner position="top-center" richColors closeButton {...props} />;
}
